import Tanamas1 from '../../../media/GW/Tanamas.webp'
import Tanamas2 from '../../../media/GW/Tanamas.webp'


const Tanamasimages =[
Tanamas1,Tanamas2
]

export default Tanamasimages;